export default __webpack_public_path__ + "static/media/hot-galvanizing-icon-dark.838e63d4.svg";